class ItcCustomSelect {
    static EL = "itc-select";
    static EL_SHOW = "itc-select_show";
    static EL_OPTION = "itc-select__option";
    static EL_OPTION_SELECTED = "itc-select__option_selected";
    static DATA = "[data-select]";
    static DATA_TOGGLE = '[data-select="toggle"]';

    static template(params) {
        const {name, options, targetValue} = params;
        const items = [];
        let selectedIndex = -1;
        let selectedValue = "";
        let selectedContent = "Выберите из списка";

        options.forEach((option, index) => {
            let selectedClass = "";
            if (option[0] === targetValue) {
                selectedClass = ` ${this.EL_OPTION_SELECTED}`;
                selectedIndex = index;
                selectedValue = option[0];
                selectedContent = option[1];
            }
            items.push(`<li class="itc-select__option${selectedClass}" data-select="option"
          data-value="${option[0]}" data-index="${index}">${option[1]}</li>`);
        });
        return `<button type="button" class="itc-select__toggle" name="${name}"
        value="${selectedValue}" data-select="toggle" data-index="${selectedIndex}">
        ${selectedContent}</button><div class="itc-select__dropdown">
        <ul class="itc-select__options">${items.join("")}</ul></div>`;
    }

    static hideOpenSelect() {
        document.addEventListener("click", (e) => {
            if (!e.target.closest(`.${this.EL}`)) {
                const elsActive = document.querySelectorAll(`.${this.EL_SHOW}`);
                elsActive.forEach((el) => {
                    el.classList.remove(this.EL_SHOW);
                });
            }
        });
    }

    static create(target, params) {
        this._el =
            typeof target === "string"
                ? document.querySelector(target)
                : target;
        if (this._el) {
            return new this(target, params);
        }
        return null;
    }

    constructor(target, params) {
        this._el =
            typeof target === "string"
                ? document.querySelector(target)
                : target;
        this._params = params || {};
        this._onClickFn = this._onClick.bind(this);
        if (this._params.options) {
            this._el.innerHTML = this.constructor.template(this._params);
            this._el.classList.add(this.constructor.EL);
        }
        this._elToggle = this._el.querySelector(this.constructor.DATA_TOGGLE);
        this._el.addEventListener("click", this._onClickFn);
    }

    _onClick(e) {
        const {target} = e;
        const type = target.closest(this.constructor.DATA).dataset.select;
        if (type === "toggle") {
            this.toggle();
        } else if (type === "option") {
            this._changeValue(target);
        }
    }

    _updateOption(el) {
        const elOption = el.closest(`.${this.constructor.EL_OPTION}`);
        const elOptionSel = this._el.querySelector(
            `.${this.constructor.EL_OPTION_SELECTED}`
        );
        if (elOptionSel) {
            elOptionSel.classList.remove(this.constructor.EL_OPTION_SELECTED);
        }
        elOption.classList.add(this.constructor.EL_OPTION_SELECTED);
        this._elToggle.textContent = elOption.textContent;
        this._elToggle.innerHTML = elOption.innerHTML;
        this._elToggle.value = elOption.dataset.value;
        this._elToggle.dataset.index = elOption.dataset.index;
        this._el.dispatchEvent(new CustomEvent("itc.select.change"));
        this._params.onSelected
            ? this._params.onSelected(this, elOption)
            : null;


        if (this._el.id === 'select-lang' || this._el.id === 'select-lang-mobile') {
            /*let elem = this._el.querySelector('[class="itc-select__toggle"]');
            console.log(elem);
            console.log(elem.getAttribute('value'));  */
            window.location = '/lang/' + this.value.toLowerCase();
        }
        if (this._el.id === 'select-currency' || this._el.id === 'select-currency-mobile') {
            window.changeCurrency(this.value);
            window.selectedCurr = this.value;

            fetch('/set-currency/' + this.value)
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                })
        }


        return elOption.dataset.value;
    }

    _reset() {
        const selected = this._el.querySelector(
            `.${this.constructor.EL_OPTION_SELECTED}`
        );
        if (selected) {
            selected.classList.remove(this.constructor.EL_OPTION_SELECTED);
        }
        this._elToggle.textContent = "Выберите из списка";
        this._elToggle.value = "";
        this._elToggle.dataset.index = "-1";
        this._el.dispatchEvent(new CustomEvent("itc.select.change"));
        this._params.onSelected ? this._params.onSelected(this, null) : null;
        return "";
    }

    _changeValue(el) {


        if (el.classList.contains(this.constructor.EL_OPTION_SELECTED)) {
            return;
        }
        let select = el.getAttribute('data-target_select');
        let value = el.getAttribute('data-value');

        if (this._el.id === 'select-sorting') {
            let url = new URL(window.location);
            if (url.searchParams.has('sort'))
                url.searchParams.set('sort', value);
            else
                url.searchParams.append('sort', value);

            history.pushState(null, null, url.href);
            location.reload();
        }

        if (this._el.id === 'select-lang' || this._el.id === 'select-lang-mobile') {
            /*let elem = this._el.querySelector('[class="itc-select__toggle"]');
            console.log(elem);
            console.log(elem.getAttribute('value'));  */
            //window.location = '/lang/'+value;
        }

        if (select !== null) {
            select = document.getElementById(select);

            if (select) {
                select.querySelectorAll('option').forEach(function (e) {
                    e.selected = false;
                })
                select.querySelector("option[value='" + value + "']").selected = true;
            }
        }
        this._updateOption(el);
        this.hide();
    }

    show() {
        document.querySelectorAll(this.constructor.EL_SHOW).forEach((el) => {
            el.classList.remove(this.constructor.EL_SHOW);
        });
        this._el.classList.add(`${this.constructor.EL_SHOW}`);
    }

    hide() {
        this._el.classList.remove(this.constructor.EL_SHOW);
    }

    toggle() {
        this._el.classList.contains(this.constructor.EL_SHOW)
            ? this.hide()
            : this.show();
    }

    dispose() {
        this._el.removeEventListener("click", this._onClickFn);
    }

    get value() {
        return this._elToggle.value;
    }

    set value(value) {
        let isExists = false;

        this._el.querySelectorAll(".itc-select__option").forEach((option) => {
            if (option.dataset.value === value) {
                isExists = true;
                this._updateOption(option);
            }
        });
        if (!isExists) {
            this._reset();
        }
    }

    get selectedIndex() {
        return this._elToggle.dataset.index;
    }

    set selectedIndex(index) {
        const option = this._el.querySelector(
            `.select__option[data-index="${index}"]`
        );
        if (option) {
            this._updateOption(option);
        }
        this._reset();
    }
}

ItcCustomSelect.hideOpenSelect();

if (document.querySelector("#select-sorting")) {
    let selectSorting = new ItcCustomSelect("#select-sorting");
    let url = new URL(window.location);
    if (url.searchParams.has('sort'))
        selectSorting.value = url.searchParams.get('sort');

}
if (document.querySelector("#select-1")) {
    new ItcCustomSelect("#select-1");
}
if (document.querySelector("#select-2")) {
    new ItcCustomSelect("#select-2");
}
if (document.querySelector("#select-3")) {
    new ItcCustomSelect("#select-3");
}
if (document.querySelector("#select-4")) {
    new ItcCustomSelect("#select-4");
}
if (document.querySelector("#select-5")) {
    new ItcCustomSelect("#select-5");
}

if (document.querySelector("#select-currency")) {

    let options = [];

    for (let key in window.currencyRate) {
        options.push(
            [key, window.currencyRate[key].symbol]
        )
    }

    new ItcCustomSelect("#select-currency", {
        name: "lang",
        targetValue: window.selectedCurr,
        options: options,
    });
    //document.querySelector('#select-currency .itc-select__dropdown li[data-value="GBP"]').style.display = 'none';

}
if (document.querySelector("#select-currency-mobile")) {

    let options = [];

    for (let key in window.currencyRate) {
        options.push(
            [key, window.currencyRate[key].symbol]
        )
    }

    new ItcCustomSelect("#select-currency-mobile", {
        name: "lang",
        targetValue: window.selectedCurr,
        options: options,
    });
    //document.querySelector('#select-currency .itc-select__dropdown li[data-value="GBP"]').style.display = 'none';

}

if (document.querySelector("#select-lang")) {
    //console.log(currentLang);
    let options = [
        [
            "RU",
            '  <img src="/img/icons/r-flag.svg" aria-hidden="true"> <span class="sub-name">RU</span>',
        ],
        [
            "EN",
            '  <img src="/img/icons/e-flag.svg" aria-hidden="true"> <span class="sub-name">EN</span>',
        ],
        [
            "TR",
            '  <img src="/img/icons/t-flag.svg" aria-hidden="true"> <span class="sub-name">TR</span>',
        ],
    ];
    /* for (let key in options) {
         if (options[key][0] === currentLang.toUpperCase()) {
             options.splice(key, 1);
         }
     }*/
    //console.log(options);


    new ItcCustomSelect("#select-lang", {
        name: "lang",
        targetValue: currentLang.toUpperCase(),
        options: options,
    });
    document.querySelector('#select-lang .itc-select__dropdown li[data-value="' + currentLang.toUpperCase() + '"]').style.display = 'none';

}
if (document.querySelector("#select-lang-mobile")) {
    new ItcCustomSelect("#select-lang-mobile", {
        name: "lang",
        targetValue: currentLang.toUpperCase(),
        options: [
            [
                "RU",
                '  <img src="/img/icons/r-flag.svg" aria-hidden="true"> <span class="sub-name">RU</span>',
            ],
            [
                "EN",
                '  <img src="/img/icons/e-flag.svg" aria-hidden="true"> <span class="sub-name">EN</span>',
            ],
            [
                "TR",
                '  <img src="/img/icons/t-flag.svg" aria-hidden="true"> <span class="sub-name">TR</span>',
            ],
        ],
    });
    document.querySelector('#select-lang-mobile .itc-select__dropdown li[data-value="' + currentLang.toUpperCase() + '"]').style.display = 'none';

}
